import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { logEventSafe } from '../../analytics/analytics';
import { SUPPORT_EMAIL } from '../../content/siteContent';
import { PageBackLink, PageHero, PagePanel, PageShell } from '../MarketingPageShell';

const ContactPage = () => {
  const location = useLocation();

  useEffect(() => {
    logEventSafe('page_view', { page_path: location.pathname, page_title: 'Contact' });
  }, [location.pathname]);

  return (
    <PageShell>
      <div className="space-y-10 py-4">
        <PageBackLink />
        <div className="mx-auto max-w-3xl space-y-8">
          <PageHero eyebrow="Support" title="Contact Toolip" description="A direct line for support, product questions, and business inquiries." />

          <PagePanel className="space-y-6">
            <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6">
              <h2 className="mb-3 text-xl font-semibold text-white">Email</h2>
              <p className="text-gray-300">{SUPPORT_EMAIL}</p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6">
              <h2 className="mb-3 text-xl font-semibold text-white">What to send</h2>
              <p className="text-gray-300">
                Bug reports, product questions, feature ideas, pricing questions, and team-plan inquiries are all welcome.
              </p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6">
              <h2 className="mb-3 text-xl font-semibold text-white">Helpful next steps</h2>
              <div className="flex flex-wrap gap-3">
                <Link to="/updates" className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-2 text-gray-200 transition-colors hover:bg-white/[0.08] hover:text-white">View updates</Link>
                <Link to="/pricing" className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-2 text-gray-200 transition-colors hover:bg-white/[0.08] hover:text-white">See pricing</Link>
              </div>
            </div>
          </PagePanel>
        </div>
      </div>
    </PageShell>
  );
};

export default ContactPage;
